import React from 'react';
import { SocialandEmotional } from '../views';

const SignupSimplePage = () => {
  return <SocialandEmotional />;
};

export default SignupSimplePage;
